import { IRouteDirection, IRouteStop } from 'features/Routes/types'
import { GTCompanyLineAutocomplete, GTCreateTRouteInput, GTPlace, GTPlaceSuggestion } from 'gql/types.generated'
import { isEmpty } from 'lodash'
import { round } from 'utils/math'

export const mapPlacesToRouteStops = (places: GTPlace[]): IRouteStop[] => {
  return places
    .filter(({ location }) => !isEmpty(location?.latitude) || !isEmpty(location?.latitude))
    .map((stop: GTPlace, index: number) => ({
      id: String(index),
      name: stop.name,
      position: {
        lat: parseFloat(stop.location.latitude),
        lng: parseFloat(stop.location.longitude)
      }
    }))
}

const mapFormToCreateMutationV2 = (values: TSFixMe, direction?: IRouteDirection): GTCreateTRouteInput => {
  let stops = values.stops
  let distance = values.distance
  let shape = values.encodedShape
  let name = values.inboundRouteName

  if (direction === IRouteDirection.OUTBOUND) {
    stops = values.outboundStops
    distance = values.outboundDistance
    shape = values.encodedOutboundShape
    name = values.outboundRouteName
  }

  const input: GTCreateTRouteInput = {
    companyID: values.company.id,
    companyLineIDs: values.lines.map(({ id }: GTCompanyLineAutocomplete) => id),
    name: name,
    polyline: {
      encoded: shape,
      distance: Number(distance)
    },
    stopIDs: [...stops.map(({ id }: GTPlace) => id)],
    businessSiteID: values.site.id || undefined,
    businessClientID: values.client.id || undefined
  }
  return input
}

const getDistanceLabel = (formValues: TSFixMe): string => {
  const distance = Number(formValues.distance) + Number(formValues.outboundDistance || 0)
  const distanceInKm = round(distance / 1000, 2)

  return String(distanceInKm)
}
export interface MapStopIdsError extends Error {
  placeId?: string
}
const mapStopIdsToRouteStops = (
  stopIds: string[],
  placesList: Pick<GTPlaceSuggestion, 'id' | 'name' | 'location'>[]
): IRouteStop[] => {
  return stopIds.map((stopId): IRouteStop => {
    const place = placesList.find((place) => place.id === stopId)
    const placeLocation = place?.location
    if (!placeLocation || !placeLocation.latitude || !placeLocation.longitude) {
      const error: MapStopIdsError = new Error(`Place ${stopId} has no location`)
      error.placeId = stopId
      throw error
    }
    return {
      id: stopId,
      name: place.name,
      position: {
        lat: Number(placeLocation.latitude),
        lng: Number(placeLocation.longitude)
      }
    }
  })
}

export const routeFormUtils = {
  getDistanceLabel,
  mapFormToCreateMutationV2,
  mapStopIdsToRouteStops
}
